import { DocumentTextIcon } from '@heroicons/react/outline';
import Link from 'next/link';
import cx from 'classnames';
import Highlight from './highlight';

function ResultPanel({
  autocomplete,
  autocompleteState,
  panelRef,
  onResultClick,
  isLightMode
}) {
  const [collection] = autocompleteState.collections;
  const count = collection?.items?.length;
  const height = count * 135 + 50; // Dynamic height based on item count

  return (
    <div className="relative w-[600px]" style={{ height }}>
      <div
        ref={panelRef}
        className={[
          'aa-Panel',
          'aa-Panel--desktop',
          autocompleteState.status === 'stalled' && 'aa-Panel--stalled',
          isLightMode
            ? '!bg-white'
            : '!bg-gray-800 !shadow-none !border !border-gray-600'
        ]
          .filter(Boolean)
          .join(' ')}
        {...autocomplete.getPanelProps({})}
      >
        <div className="aa-PanelLayout aa-Panel--scrollable">
          {autocompleteState.collections.map((collection, index) => {
            const { source, items } = collection;

            return (
              <section key={`source-${index}`} className=" aa-Source">
                {items.length > 0 && (
                  <ul className=" aa-List" {...autocomplete.getListProps()}>
                    {items.map((item, index) => {
                      return (
                        <li
                          key={item.objectID}
                          className={cx(
                            'aa-Item',
                            'w-[80vw] md:w-[58vw] lg:w-[570px] h-auto py-4',
                            isLightMode
                              ? 'hover:!bg-gray-100'
                              : 'hover:!bg-gray-900',
                            index !== items.length - 1 &&
                              'border-solid border-b-2 border-gray-100'
                          )}
                          {...autocomplete.getItemProps({ item, source })}
                        >
                          <Link legacyBehavior href={item.slug}>
                            <a
                              className="aa-ItemWrapper"
                              onClick={onResultClick}
                            >
                              <div className="aa-ItemContent">
                                <div
                                  className={cx(
                                    'aa-ItemContentBody',
                                    'w-[80vw]'
                                  )}
                                >
                                  <div
                                    className={cx(
                                      'aa-ItemContentTitle',
                                      isLightMode
                                        ? '!text-gray-900'
                                        : '!text-gray-100'
                                    )}
                                  >
                                    {item.title}
                                  </div>
                                  <div
                                    className={cx(
                                      'aa-ItemContentDescription',
                                      isLightMode
                                        ? '!text-gray-900'
                                        : '!text-gray-200'
                                    )}
                                  >
                                    <Highlight
                                      hit={item}
                                      attribute="description"
                                      isLightMode={isLightMode}
                                    />
                                  </div>
                                  <div
                                    className={cx(
                                      'aa-ItemContentDescription max-h-16 mt-2 overflow-hidden',
                                      isLightMode
                                        ? '!text-gray-900'
                                        : '!text-gray-200'
                                    )}
                                  >
                                    <Highlight
                                      hit={item}
                                      attribute="body"
                                      isLightMode={isLightMode}
                                    />
                                    <p>...</p>
                                  </div>
                                </div>
                              </div>
                              <div className="aa-ItemActions">
                                <button
                                  className="aa-ItemActionButton aa-DesktopOnly aa-ActiveOnly"
                                  type="button"
                                  title="Select"
                                  style={{ pointerEvents: 'none' }}
                                >
                                  <svg
                                    className={
                                      isLightMode
                                        ? '!fill-gray-500'
                                        : '!fill-gray-100'
                                    }
                                    viewBox="0 0 24 24"
                                  >
                                    <path d="M18.984 6.984h2.016v6h-15.188l3.609 3.609-1.406 1.406-6-6 6-6 1.406 1.406-3.609 3.609h13.172v-4.031z" />
                                  </svg>
                                </button>
                              </div>
                            </a>
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </section>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default ResultPanel;
